// RU-PAPERFLATTEN (PF-8): the PANIC EXIT ALL toast, built from the POST /paper/flatten response
// {closed, skipped: [{id, symbol, qty, status, reason, closed_elsewhere?}], realised_pnl, estimated: [ids],
//  warnings: [{id, symbol, reason}]}.

// PF-15: a 409 whose position another order already closed is not "still open".
const closedElsewhere = (s) =>
  s.closed_elsewhere === true || (Number(s.status) === 409 && /closed by another order/i.test(String(s.reason || "")));

const money = (n) =>
  `${n < 0 ? "-" : ""}₹${Math.abs(Number(n)).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function flattenToast(data) {
  const closed = Number(data?.closed) || 0;
  const skipped = Array.isArray(data?.skipped) ? data.skipped : [];
  const estimated = Array.isArray(data?.estimated) ? data.estimated : [];
  const warnings = Array.isArray(data?.warnings) ? data.warnings : [];
  // PF-11: the kill switch refuses every close (423); say so instead of listing N identical skips.
  const killed = skipped.filter((s) => Number(s.status) === 423);
  const elsewhere = skipped.filter((s) => Number(s.status) !== 423 && closedElsewhere(s));
  const others = skipped.filter((s) => Number(s.status) !== 423 && !closedElsewhere(s));
  const counts = `closed ${closed}, skipped ${skipped.length}`;
  const title = killed.length > 0 ? `Kill switch is active: ${counts}` : `Closed ${closed}, skipped ${skipped.length}`;
  const parts = [];
  // PF-15: a position that grew while closing books P&L with closed 0; show it whenever there is any.
  const pnl = Number(data?.realised_pnl);
  if (data?.realised_pnl !== undefined && data?.realised_pnl !== null && (closed > 0 || pnl !== 0)) {
    parts.push(`Realised P&L ${money(data.realised_pnl)}`);
  }
  if (estimated.length > 0) parts.push(`${estimated.length} closed without a live quote (P&L estimated)`);
  if (killed.length > 0) {
    parts.push(`${killed.length} position${killed.length === 1 ? "" : "s"} left open: disable the kill switch to close them`);
  }
  if (elsewhere.length > 0) {
    parts.push(`Already closed elsewhere: ${elsewhere.map((s) => s.symbol || s.id).join(", ")}`);
  }
  if (warnings.length > 0) {
    parts.push(`Check: ${warnings.map((w) => `${w.symbol || w.id} (${w.reason || "warning"})`).join("; ")}`);
  }
  if (others.length > 0) {
    parts.push(`Still open: ${others.map((s) => `${s.symbol || s.id} (${s.reason || "refused"})`).join("; ")}`);
  }
  const tone = others.length > 0 || killed.length > 0 || warnings.length > 0 ? "warning" : "success";
  return { tone, title, description: parts.join(" · ") || undefined };
}

export function flattenErrorText(err) {
  if (err?.response?.status === 409) return "Panic exit already running";
  const detail = err?.response?.data?.detail;
  return typeof detail === "string" && detail ? detail : "Panic exit failed";
}
